/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type DiscoveredOrganizationFragment = { __typename: 'DiscoveredOrganizationType', organizationId?: string | null, organizationName?: string | null };

export type RequestOAuthDiscoveryUrlMutationVariables = Types.Exact<{
  provider: Types.ProviderEnum;
}>;


export type RequestOAuthDiscoveryUrlMutation = { __typename: 'Mutation', requestOauthDiscoveryUrl?: { __typename: 'RequestOAuthDiscoveryUrlMutation', url?: string | null } | null };

export type RequestEmailDiscoveryTokenMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type RequestEmailDiscoveryTokenMutation = { __typename: 'Mutation', requestEmailDiscoveryToken?: { __typename: 'RequestEmailDiscoveryTokenMutation', success?: boolean | null, message?: string | null } | null };

export type ValidateDiscoveryTokenMutationVariables = Types.Exact<{
  stytchTokenType: Types.StytchTokenTypeEnum;
  token: Types.Scalars['String']['input'];
}>;


export type ValidateDiscoveryTokenMutation = { __typename: 'Mutation', validateDiscoveryToken?: { __typename: 'ValidateDiscoveryTokenMutation', success?: boolean | null, intermediateSessionToken?: string | null, discoveredOrganizations?: Array<{ __typename: 'DiscoveredOrganizationType', organizationId?: string | null, organizationName?: string | null } | null> | null } | null };

export type AuthenticateOrganizationMutationVariables = Types.Exact<{
  stytchOrganizationId: Types.Scalars['String']['input'];
  token: Types.Scalars['String']['input'];
}>;


export type AuthenticateOrganizationMutation = { __typename: 'Mutation', authenticateOrganization?: { __typename: 'AuthenticateOrganizationMutation', organizationSlug: string } | null };

export type AcceptInvitationMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type AcceptInvitationMutation = { __typename: 'Mutation', acceptInvitation?: { __typename: 'AcceptInvitationMutation', organizationSlug: string } | null };

export type AuthenticateImpersonationTokenMutationVariables = Types.Exact<{
  impersonationToken: Types.Scalars['String']['input'];
}>;


export type AuthenticateImpersonationTokenMutation = { __typename: 'Mutation', authenticateImpersonationToken?: { __typename: 'AuthenticateImpersonationTokenMutation', organizationSlug: string, userId: string, impersonationSession?: boolean | null } | null };

export type ListOrganizationsFromDiscoveryMutationVariables = Types.Exact<{
  intermediateSessionToken: Types.Scalars['String']['input'];
}>;


export type ListOrganizationsFromDiscoveryMutation = { __typename: 'Mutation', listOrganizationsFromDiscovery?: { __typename: 'ListOrganizationsFromDiscoveryMutation', discoveredOrganizations?: Array<{ __typename: 'DiscoveredOrganizationType', organizationId?: string | null, organizationName?: string | null } | null> | null } | null };

export type CreateOrganizationFromDiscoveryMutationVariables = Types.Exact<{
  input: Types.CreateOrganizationFromDiscoveryInput;
}>;


export type CreateOrganizationFromDiscoveryMutation = { __typename: 'Mutation', createOrganizationFromDiscovery?: { __typename: 'CreateOrganizationFromDiscoveryMutation', success: boolean } | null };

export type DestroySessionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DestroySessionMutation = { __typename: 'Mutation', destroyUserSession?: { __typename: 'DestroySessionMutation', success: boolean } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const DiscoveredOrganizationFragmentDoc = new TypedDocumentString(`
    fragment DiscoveredOrganization on DiscoveredOrganizationType {
  organizationId
  organizationName
}
    `, {"fragmentName":"DiscoveredOrganization"});
export const RequestOAuthDiscoveryUrlDocument = new TypedDocumentString(`
    mutation RequestOAuthDiscoveryUrl($provider: ProviderEnum!) {
  requestOauthDiscoveryUrl(provider: $provider) {
    url
  }
}
    `);

export const useRequestOAuthDiscoveryUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestOAuthDiscoveryUrlMutation, TError, RequestOAuthDiscoveryUrlMutationVariables, TContext>) => {
    
    return useMutation<RequestOAuthDiscoveryUrlMutation, TError, RequestOAuthDiscoveryUrlMutationVariables, TContext>(
      {
    mutationKey: ['RequestOAuthDiscoveryUrl'],
    mutationFn: (variables?: RequestOAuthDiscoveryUrlMutationVariables) => fetcher<RequestOAuthDiscoveryUrlMutation, RequestOAuthDiscoveryUrlMutationVariables>(RequestOAuthDiscoveryUrlDocument, variables)(),
    ...options
  }
    )};


useRequestOAuthDiscoveryUrlMutation.fetcher = (variables: RequestOAuthDiscoveryUrlMutationVariables) => fetcher<RequestOAuthDiscoveryUrlMutation, RequestOAuthDiscoveryUrlMutationVariables>(RequestOAuthDiscoveryUrlDocument, variables);

export const RequestEmailDiscoveryTokenDocument = new TypedDocumentString(`
    mutation RequestEmailDiscoveryToken($email: String!) {
  requestEmailDiscoveryToken(email: $email) {
    success
    message
  }
}
    `);

export const useRequestEmailDiscoveryTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestEmailDiscoveryTokenMutation, TError, RequestEmailDiscoveryTokenMutationVariables, TContext>) => {
    
    return useMutation<RequestEmailDiscoveryTokenMutation, TError, RequestEmailDiscoveryTokenMutationVariables, TContext>(
      {
    mutationKey: ['RequestEmailDiscoveryToken'],
    mutationFn: (variables?: RequestEmailDiscoveryTokenMutationVariables) => fetcher<RequestEmailDiscoveryTokenMutation, RequestEmailDiscoveryTokenMutationVariables>(RequestEmailDiscoveryTokenDocument, variables)(),
    ...options
  }
    )};


useRequestEmailDiscoveryTokenMutation.fetcher = (variables: RequestEmailDiscoveryTokenMutationVariables) => fetcher<RequestEmailDiscoveryTokenMutation, RequestEmailDiscoveryTokenMutationVariables>(RequestEmailDiscoveryTokenDocument, variables);

export const ValidateDiscoveryTokenDocument = new TypedDocumentString(`
    mutation ValidateDiscoveryToken($stytchTokenType: StytchTokenTypeEnum!, $token: String!) {
  validateDiscoveryToken(stytchTokenType: $stytchTokenType, token: $token) {
    success
    intermediateSessionToken
    discoveredOrganizations {
      ...DiscoveredOrganization
    }
  }
}
    fragment DiscoveredOrganization on DiscoveredOrganizationType {
  organizationId
  organizationName
}`);

export const useValidateDiscoveryTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateDiscoveryTokenMutation, TError, ValidateDiscoveryTokenMutationVariables, TContext>) => {
    
    return useMutation<ValidateDiscoveryTokenMutation, TError, ValidateDiscoveryTokenMutationVariables, TContext>(
      {
    mutationKey: ['ValidateDiscoveryToken'],
    mutationFn: (variables?: ValidateDiscoveryTokenMutationVariables) => fetcher<ValidateDiscoveryTokenMutation, ValidateDiscoveryTokenMutationVariables>(ValidateDiscoveryTokenDocument, variables)(),
    ...options
  }
    )};


useValidateDiscoveryTokenMutation.fetcher = (variables: ValidateDiscoveryTokenMutationVariables) => fetcher<ValidateDiscoveryTokenMutation, ValidateDiscoveryTokenMutationVariables>(ValidateDiscoveryTokenDocument, variables);

export const AuthenticateOrganizationDocument = new TypedDocumentString(`
    mutation AuthenticateOrganization($stytchOrganizationId: String!, $token: String!) {
  authenticateOrganization(
    stytchOrganizationId: $stytchOrganizationId
    token: $token
  ) {
    organizationSlug
  }
}
    `);

export const useAuthenticateOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AuthenticateOrganizationMutation, TError, AuthenticateOrganizationMutationVariables, TContext>) => {
    
    return useMutation<AuthenticateOrganizationMutation, TError, AuthenticateOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['AuthenticateOrganization'],
    mutationFn: (variables?: AuthenticateOrganizationMutationVariables) => fetcher<AuthenticateOrganizationMutation, AuthenticateOrganizationMutationVariables>(AuthenticateOrganizationDocument, variables)(),
    ...options
  }
    )};


useAuthenticateOrganizationMutation.fetcher = (variables: AuthenticateOrganizationMutationVariables) => fetcher<AuthenticateOrganizationMutation, AuthenticateOrganizationMutationVariables>(AuthenticateOrganizationDocument, variables);

export const AcceptInvitationDocument = new TypedDocumentString(`
    mutation AcceptInvitation($token: String!) {
  acceptInvitation(token: $token) {
    organizationSlug
  }
}
    `);

export const useAcceptInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptInvitationMutation, TError, AcceptInvitationMutationVariables, TContext>) => {
    
    return useMutation<AcceptInvitationMutation, TError, AcceptInvitationMutationVariables, TContext>(
      {
    mutationKey: ['AcceptInvitation'],
    mutationFn: (variables?: AcceptInvitationMutationVariables) => fetcher<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, variables)(),
    ...options
  }
    )};


useAcceptInvitationMutation.fetcher = (variables: AcceptInvitationMutationVariables) => fetcher<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, variables);

export const AuthenticateImpersonationTokenDocument = new TypedDocumentString(`
    mutation AuthenticateImpersonationToken($impersonationToken: String!) {
  authenticateImpersonationToken(impersonationToken: $impersonationToken) {
    organizationSlug
    userId
    impersonationSession
  }
}
    `);

export const useAuthenticateImpersonationTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AuthenticateImpersonationTokenMutation, TError, AuthenticateImpersonationTokenMutationVariables, TContext>) => {
    
    return useMutation<AuthenticateImpersonationTokenMutation, TError, AuthenticateImpersonationTokenMutationVariables, TContext>(
      {
    mutationKey: ['AuthenticateImpersonationToken'],
    mutationFn: (variables?: AuthenticateImpersonationTokenMutationVariables) => fetcher<AuthenticateImpersonationTokenMutation, AuthenticateImpersonationTokenMutationVariables>(AuthenticateImpersonationTokenDocument, variables)(),
    ...options
  }
    )};


useAuthenticateImpersonationTokenMutation.fetcher = (variables: AuthenticateImpersonationTokenMutationVariables) => fetcher<AuthenticateImpersonationTokenMutation, AuthenticateImpersonationTokenMutationVariables>(AuthenticateImpersonationTokenDocument, variables);

export const ListOrganizationsFromDiscoveryDocument = new TypedDocumentString(`
    mutation ListOrganizationsFromDiscovery($intermediateSessionToken: String!) {
  listOrganizationsFromDiscovery(
    intermediateSessionToken: $intermediateSessionToken
  ) {
    discoveredOrganizations {
      ...DiscoveredOrganization
    }
  }
}
    fragment DiscoveredOrganization on DiscoveredOrganizationType {
  organizationId
  organizationName
}`);

export const useListOrganizationsFromDiscoveryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ListOrganizationsFromDiscoveryMutation, TError, ListOrganizationsFromDiscoveryMutationVariables, TContext>) => {
    
    return useMutation<ListOrganizationsFromDiscoveryMutation, TError, ListOrganizationsFromDiscoveryMutationVariables, TContext>(
      {
    mutationKey: ['ListOrganizationsFromDiscovery'],
    mutationFn: (variables?: ListOrganizationsFromDiscoveryMutationVariables) => fetcher<ListOrganizationsFromDiscoveryMutation, ListOrganizationsFromDiscoveryMutationVariables>(ListOrganizationsFromDiscoveryDocument, variables)(),
    ...options
  }
    )};


useListOrganizationsFromDiscoveryMutation.fetcher = (variables: ListOrganizationsFromDiscoveryMutationVariables) => fetcher<ListOrganizationsFromDiscoveryMutation, ListOrganizationsFromDiscoveryMutationVariables>(ListOrganizationsFromDiscoveryDocument, variables);

export const CreateOrganizationFromDiscoveryDocument = new TypedDocumentString(`
    mutation CreateOrganizationFromDiscovery($input: CreateOrganizationFromDiscoveryInput!) {
  createOrganizationFromDiscovery(input: $input) {
    success
  }
}
    `);

export const useCreateOrganizationFromDiscoveryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrganizationFromDiscoveryMutation, TError, CreateOrganizationFromDiscoveryMutationVariables, TContext>) => {
    
    return useMutation<CreateOrganizationFromDiscoveryMutation, TError, CreateOrganizationFromDiscoveryMutationVariables, TContext>(
      {
    mutationKey: ['CreateOrganizationFromDiscovery'],
    mutationFn: (variables?: CreateOrganizationFromDiscoveryMutationVariables) => fetcher<CreateOrganizationFromDiscoveryMutation, CreateOrganizationFromDiscoveryMutationVariables>(CreateOrganizationFromDiscoveryDocument, variables)(),
    ...options
  }
    )};


useCreateOrganizationFromDiscoveryMutation.fetcher = (variables: CreateOrganizationFromDiscoveryMutationVariables) => fetcher<CreateOrganizationFromDiscoveryMutation, CreateOrganizationFromDiscoveryMutationVariables>(CreateOrganizationFromDiscoveryDocument, variables);

export const DestroySessionDocument = new TypedDocumentString(`
    mutation DestroySession {
  destroyUserSession {
    success
  }
}
    `);

export const useDestroySessionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DestroySessionMutation, TError, DestroySessionMutationVariables, TContext>) => {
    
    return useMutation<DestroySessionMutation, TError, DestroySessionMutationVariables, TContext>(
      {
    mutationKey: ['DestroySession'],
    mutationFn: (variables?: DestroySessionMutationVariables) => fetcher<DestroySessionMutation, DestroySessionMutationVariables>(DestroySessionDocument, variables)(),
    ...options
  }
    )};


useDestroySessionMutation.fetcher = (variables?: DestroySessionMutationVariables) => fetcher<DestroySessionMutation, DestroySessionMutationVariables>(DestroySessionDocument, variables);
